import moment from 'moment'
import { constants } from '@/plugins/App'
import { actions as collection } from '@/plugins/Collection'

export default class {
  /**
   * Get the date the investment loan ends.
   *
   * @param {Object} investment
   * @returns {String}
   */
  static endingAt (investment) {
    return moment(investment.loanStartedAt, constants.DATE_FORMAT)
      .add(investment.project.facility.term, 'months')
      .format(constants.DATE_FORMAT)
  }

  /**
   * Get the investment interest payment type.
   *
   * @param {String} type
   * @returns {String}
   */
  static getInterestPaymentType (type) {
    return collection.getValue(require('../data/interestPaymentTypes.js').default, type)
  }

  /**
   * Get the investment type.
   *
   * @param {String} type
   * @returns {String}
   */
  static getInvestmentType (type) {
    return collection.getValue(require('../data/investmentTypes.js').default, type)
  }

  /**
   * Get the investment payment schedule.
   *
   * @param {String} type
   * @returns {String}
   */
  static getPaymentSchedule (type) {
    return collection.getValue(require('../data/paymentSchedule.js').default, type)
  }

  /**
   * Get the investment security type.
   *
   * @param {String} type
   * @returns {String}
   */
  static getSecurityType (type) {
    return collection.getValue(require('../data/investmentSecurityTypes.js').default, type)
  }

  /**
   * Get the number of months remaining on the loan.
   *
   * @param {Object} investment
   * @returns {String}
   */
  static termRemaining (investment) {
    const { project, loanStartedAt } = investment
    const { term } = project.facility
    const now = moment()
    const start = moment(loanStartedAt, constants.DATE_FORMAT)
    let remaining = Number(term)

    if (start.isBefore(now)) {
      remaining = now.diff(start, 'months')
    }

    const suffix = remaining !== 1 ? 'months' : 'month'

    return `${remaining} ${suffix}`
  }

  /**
   * Check that a valid investment amount has been supplied against this investment.
   *
   * @param {Object} investment
   * @param {Number} amount
   * @returns {Boolean}
   */
  static validInvestmentAmount ({ costPerShare }, amount) {
    return amount % costPerShare === 0
  }
}
